export const ds_LinksBlock_Entry = `
    fragment ds_LinksBlock_Entry on ds_LinksBlock_Entry {
        id
        canonicalUid

        links_TextColor
        links_ColorPalette
        links_ColorTheme
        links_TopSpacing
        links_ContainerWidth
        links_FullWidthBackground

        links_ColumnsDesktop
        links_Links {
            text
            target
            title
            url
            ariaLabel
            ... on links_Links_Custom_LinkType {
                description
                icon {
                    name
                    set
                    type
                }
            }
            ... on links_Links_Entry_LinkType {
                description
                icon {
                    name
                    set
                    type
                }
            }
            ... on links_Links_Url_LinkType {
                description
                icon {
                    name
                    set
                    type
                }
            }
            ... on links_Links_Phone_LinkType {
                description
                icon {
                    name
                    set
                    type
                }
            }
            ... on links_Links_Email_LinkType {
                description
                icon {
                    name
                    set
                    type
                }
            }
        }
    }
`